import { useEffect, useState } from 'react'
import { useSupabaseAuth } from '../../../lib/useSupabaseAuth'
import { supabase } from '../../../lib/supabase'
import { useDemoMode } from '../../../hooks/useDemoMode'
import CompanyInfoModal from './CompanyInfoModal'

const CompanyInfoGate = ({ children }) => {
  const { user, authReady, loading, isAuthenticated, companyId } = useSupabaseAuth()
  const { isDemoMode } = useDemoMode()
  const [employeeCheck, setEmployeeCheck] = useState({ checked: false, isEmployee: false })

  const needsCompanyInfo =
    !isDemoMode && authReady && !loading && isAuthenticated && !companyId

  useEffect(() => {
    let cancelled = false
    if (!needsCompanyInfo || !user?.id) {
      setEmployeeCheck({ checked: !needsCompanyInfo, isEmployee: false })
      return
    }
    const verify = async () => {
      try {
        const { data, error } = await supabase
          .from('employees')
          .select('id, company_id, status')
          .eq('user_id', user.id)
          .limit(1)
          .maybeSingle()
        if (cancelled) return
        const hasEmployeeLink = !error && !!data?.company_id
        setEmployeeCheck({ checked: true, isEmployee: hasEmployeeLink })
      } catch (_err) {
        if (!cancelled) setEmployeeCheck({ checked: true, isEmployee: false })
      }
    }
    verify()
    return () => {
      cancelled = true
    }
  }, [needsCompanyInfo, user?.id])

  const showModal = needsCompanyInfo && employeeCheck.checked && !employeeCheck.isEmployee

  return (
    <>
      {children}
      {showModal && <CompanyInfoModal />}
    </>
  )
}

export default CompanyInfoGate
